<template>
  <b-card class="filter">
    <h3 class="pb-4">Filter messages</h3>

    <div class="row">
      <div class="col-3">
        <SimpleDropdown v-model="senderType" :options="senderTypesData" />
      </div>
      <div class="col-3 date-block">
        <VueDatePicker
          v-model="sentAt"
          format="yyyy-MM-dd"
          range
          multi-calendars
          placeholder="Sent at"
          :clearable="true"
        >
        </VueDatePicker>
      </div>

      <div class="col-3 offset-3 text-right">
        <b-button @click="submit"> Submit </b-button>
        <b-button v-if="hasFilters" class="ml-2" variant="secondary" @click="reset"> Reset </b-button>
      </div>
    </div>
  </b-card>
</template>

<script lang="ts">
import type { ShipmentEventsListQueryParams } from '@/types/Components/SearchForm'
import type { SelectOptions } from '@/types/Components/SelectOptions'
import type { ComputedRef, Ref } from 'vue'
import { VueDatePicker } from '@vuepic/vue-datepicker'
import { BButton, BCard } from 'bootstrap-vue-next'
import { ref, computed, watch, onMounted, defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { CARRIER_MESSAGES } from '@/types/router'
import moment from 'moment'
import SimpleDropdown from '@/views/Components/PageParts/SimpleDropdown.vue'

export default defineComponent({
  name: 'CarrierMessagesSearchForm',
  components: { BCard, BButton, SimpleDropdown, VueDatePicker },
  setup() {
    const route = useRoute()
    const router = useRouter()

    const senderType: Ref<string | undefined> = ref(undefined)
    const sentAt: Ref<string[] | null> = ref(null)
    const routeHandle = CARRIER_MESSAGES

    const senderTypesData: SelectOptions[] = [
      { value: null, text: 'From carrier and recipient' },
      { value: 'carrier', text: 'From carrier' },
      { value: 'recipient', text: 'From recipient' },
    ]

    const hasFilters: ComputedRef<boolean> = computed(() => Boolean(senderType.value || sentAt.value))

    const submit = () => {
      const query = {} as ShipmentEventsListQueryParams

      query.senderType = senderType.value ? String(senderType.value) : undefined

      if (sentAt.value && Array.isArray(sentAt.value) && sentAt.value.length === 2) {
        const [dateFrom, dateTo] = sentAt.value
        query.dateFrom = moment(dateFrom).format('YYYY-MM-DD')
        query.dateTo = moment(dateTo).format('YYYY-MM-DD')
      }

      router.push({ name: routeHandle, query })
    }

    const reset = () => {
      router.push({ name: routeHandle })
    }

    watch(sentAt, submit)

    onMounted(() => {
      const routeQuery = route.query
      senderType.value = routeQuery.senderType ? String(routeQuery.senderType) : undefined

      if (routeQuery.dateFrom && routeQuery.dateTo) {
        sentAt.value = [String(routeQuery.dateFrom), String(routeQuery.dateTo)]
      }
    })

    return {
      senderTypesData,
      senderType,
      sentAt,
      routeHandle,
      hasFilters,
      submit,
      reset,
    }
  },
})
</script>
